import { render } from "./VehicleAcceptance.vue?vue&type=template&id=51baf428&scoped=true"
import script from "./VehicleAcceptance.vue?vue&type=script&lang=js"
export * from "./VehicleAcceptance.vue?vue&type=script&lang=js"

import "./VehicleAcceptance.vue?vue&type=style&index=0&id=51baf428&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51baf428"]])

export default __exports__